<div *ngIf="surveyTemplate" class="section-viewport">
    <mat-card>
        <header>
            <h3>{{ surveyTemplate.category }}</h3>
        </header>
        <content>
            <div *ngFor="let surveyQuestion of surveyTemplate.questions">
                <app-rating-survey-question [question]="surveyQuestion" [surveyChoices]="surveyChoices" [form]="form" (questionAnswered)="validateAnswers()"></app-rating-survey-question>
            </div>                
        </content>    
    </mat-card>    
</div>